import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY, BETWEEN_MD_LG_MEDIA_QUERY, LG_MEDIA_QUERY, XL_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps } from '~pricing/components/PackageHeader/types';
import { StyleRules } from './types';

export default createMemoStyles<StyleRules, StyleProps, PricingAppTheme>(
  ({ spacing, type, pricingPalette }: PricingAppTheme) => ({
    Header: {
      padding: [spacing[5], spacing[6], spacing[4]],
      fontSize: 16,
      '& h2': {
        // Package header text
        fontWeight: type.fontWeight.medium,
        fontSize: ({ isSummaryPage }: StyleProps) => (isSummaryPage ? '1.5em' : '1.25em'),
        margin: `0 0 ${spacing[4]}px`,

        [BETWEEN_MD_LG_MEDIA_QUERY]: {
          marginBottom: spacing[3],
        },
      },
      '& h3': {
        margin: 0,
        fontSize: '1em',
        whiteSpace: 'normal',

        '& > span:first-of-type': {
          fontSize: '1.75em',
        },

        '& svg': {
          margin: [spacing[1], 0],
          fontSize: 24,
        },

        [MD_MEDIA_QUERY]: {
          minHeight: 40,
        },
      },

      '& *': {
        textAlign: 'left',
      },

      [MD_MEDIA_QUERY]: {
        minHeight: 320,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
      },

      [BETWEEN_MD_LG_MEDIA_QUERY]: {
        fontSize: 12,
        paddingLeft: spacing[3],
        paddingRight: spacing[3],
      },
    },

    ToggleContainer: {
      [MD_MEDIA_QUERY]: {
        height: 50,
      },

      [LG_MEDIA_QUERY]: {
        height: spacing[8],
      },
    },

    CTA: {
      padding: 0,
    },

    Byline: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      margin: [spacing[4], 0],

      [MD_MEDIA_QUERY]: {
        minHeight: 70,
      },

      [LG_MEDIA_QUERY]: {
        minHeight: 120,
      },

      [XL_MEDIA_QUERY]: {
        minHeight: 80,
      },

      '& p': {
        fontSize: '1em',
      },

      '& > svg': {
        margin: [5, spacing[3], 0, 0],
        flex: '0 0 auto',

        [BETWEEN_MD_LG_MEDIA_QUERY]: {
          marginTop: 1,
        },
      },
    },

    Discount: {
      fontWeight: type.fontWeight.medium,
      padding: 0,
      margin: [spacing[2], 0, 0],

      '& button': {
        fontSize: '1em',
        padding: 0,
        border: 'none',
        minHeight: 'auto',
        display: 'inline-block',

        '& svg:last-child': {
          marginLeft: 0,
          fontSize: 'inherit',
        },

        '& span': {
          whiteSpace: 'nowrap',
        },

        '&:hover': {
          background: 'transparent',
          border: 'none',
        },
      },
    },

    SwitchForDiscount: {
      color: pricingPalette.colors.link,
      display: 'flex',
      alignItems: 'center',

      '& svg': {
        marginLeft: spacing[2],
      },
    },

    DiscountApplied: {
      color: pricingPalette.colors.sabaeus,
    },
  })
);
